import React from 'react';

const Incorrect = ({
	choices,
	correctAnswer,
	imgChoices,
	defaultFeedback,
	index,
	userAnswer,
	score,
}) => {
	let Choicelist = '';
	if (!!choices) {
		if (!!choices && Object.keys(choices).length > 0) {
			Choicelist = Object.keys(choices).map(function (choice) {
				if (choices[choice] === '') {
					return false;
				}
				let TxtImgChoice = choices[choice];
				if (imgChoices[choice] !== '' && imgChoices[choice] !== 'None') {
					TxtImgChoice = <img src={imgChoices[choice]} alt="" />;
				}

				let choicefb = choices[choice].toLowerCase().trim();
				let answerfb = userAnswer.toLowerCase().trim();
				let correctfb = correctAnswer.toLowerCase().trim();

				let feedbackClass = '';
				if (correctfb.includes(choicefb) && score < 0) {
					feedbackClass = 'radio-blue';
				} else if (correctfb.includes(choicefb)) {
					feedbackClass = 'correct-answer';
				} else if (answerfb.includes(choicefb) && score < 1) {
					feedbackClass = 'wrong-answer';
				}
				return (
					<li key={choice} className={feedbackClass}>
						{TxtImgChoice}
					</li>
				);
			});
		}
	}

	return (
		<span className="quiz-more-answer">
			<ul className="no-mouse-events">{Choicelist}</ul>
		</span>
	);
};

export default Incorrect;
